import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/finally';

import { StatisticService } from '../../../../services/statistic.service';
import { UserService } from '../../../../services/user.service';
import { DateCountStatistic } from '../../../../entities/index';
import { Log } from '../../../../utils/index';

@Component({
  selector: 'app-dashboard-subscription-count',
  templateUrl: './dashboard-subscription-count.html'
})
export class DashboardSubscriptionCountComponent implements OnInit {
  stats: Observable<DateCountStatistic[]>;
  statType = 'all_on_created_at';
  loading = false;

  constructor(protected statisticService: StatisticService,
              protected userService: UserService) {
  }

  @Log()
  ngOnInit() {
    this.watchCurrentUser();
  }

  @Log()
  watchCurrentUser() {
    this.userService.currentUser.subscribe(user => {
      if (user && user.id) {
        this.loadStats();
      }
    });
  }

  loadStats() {
    this.loading = true;

    let params: { period: number; payment: string; status: string; on_canceled_at: boolean };
    params = {period: null, payment: null, status: null, on_canceled_at: null};

    if (this.statType.indexOf('active_') === 0) {
      params.status = 'active';
    } else if (this.statType.indexOf('canceled_') === 0) {
      params.status = 'canceled';
    }

    if (this.statType.indexOf('_12') !== -1) {
      params.period = 12;
    } else if (this.statType.indexOf('_24') !== -1) {
      params.period = 24;
    } else if (this.statType.indexOf('_1') !== -1) {
      params.period = 1;
    }

    if (this.statType.indexOf('hipay') !== -1) {
      params.payment = 'hipay';
    } else if (this.statType.indexOf('gocardless') !== -1) {
      params.payment = 'gocardless';
    }

    if (this.statType.indexOf('canceled_at') !== -1) {
      params.on_canceled_at = true;
    }

    this.stats = this
      .statisticService
      .countSubscriptionPerMonth(params.status, params.period, params.payment, params.on_canceled_at)
      .finally(() => this.loading = false);
  }

  @Log()
  changeStatType(statType: string = null) {
    this.statType = statType;
    this.loadStats();
  }
}




// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/pages/dashboard/subscription-count/dashboard-subscription-count.component.ts